import { render, staticRenderFns } from "./finrectab.vue?vue&type=template&id=cf79f352&scoped=true&"
import script from "./finrectab.vue?vue&type=script&lang=js&"
export * from "./finrectab.vue?vue&type=script&lang=js&"
import style0 from "./finrectab.vue?vue&type=style&index=0&id=cf79f352&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf79f352",
  null
  
)

export default component.exports